import { combineReducers } from 'redux';

import country from './country';
import specialties from './specialties';
import users from './users'

export default combineReducers({
  country,
  specialties,
  users
});
